import React, { memo, useCallback } from "react";
import "../../App.css"; // Custom styles for the tree view
import { ChevronDown, ChevronUp } from "lucide-react";

const TreeView = memo(({ folders, onFolderClick, expanded }) => {
  const renderTreeItems = useCallback((folders) => {
    return folders.map((folder) => (
      <div key={folder.url} className="tree-item">
        <div
          className={`tree-item-label ${
            expanded.includes(folder.url) ? "expanded " : ""
          } `}
          onClick={(e) => {
            e.stopPropagation();
            onFolderClick(folder.url);
          }}
          
        >
          {expanded.includes(folder.url) ? <ChevronDown /> : <ChevronUp />}
          {folder.name}
        </div>
        {expanded.includes(folder.url) &&
          folder.children &&
          folder.children.length > 0 && (
            <div className="tree-children " >
              {renderTreeItems(folder.children)}
            </div>
          )}
      </div>
    ));
  }, [expanded, onFolderClick]);

  return <div className="tree-view">{renderTreeItems(folders)}</div>;
});

export default TreeView;
